module.exports = __webpack_public_path__ + "assets/img/tx121_1.fa278fed.jpg";